var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.avatarBackup.value
      ? _c(
          "div",
          {
            staticClass: "avatar relative show-hover-container",
            class: _vm.addClasses(_vm.avatarBackup.type),
            attrs: { id: "avatar" }
          },
          [
            _vm.avatarBackup.type == "picture" ||
            _vm.avatarBackup.type == "twitteruserpic"
              ? _c("img", {
                  attrs: { src: _vm.avatarBackup.value, alt: "" },
                  on: { click: _vm.goTo }
                })
              : _c("span", { on: { click: _vm.goTo } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.avatarBackup.value) +
                      "\n            "
                  )
                ]),
            _vm._v(" "),
            _vm.editable
              ? _c(
                  "div",
                  {
                    staticClass:
                      "absolute top-left bottom-right icon-16 show-hover-item cpointer primary-50-bkg white br",
                    on: { click: _vm.openAvatarModal }
                  },
                  [_c("i", { staticClass: "icon-setting absolute-center" })]
                )
              : _vm._e()
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }